import React, { useEffect, useState } from 'react';
import SearchInput from '../../../../Constants/SearchInput';
import { useDispatch, useSelector } from 'react-redux';
import {
  catTreeWithfahrast,
  getLast10Years,
  getPersianDayOfWeek,
  monthArr,
  pad,
  persianDate,
} from '../../../../module/ConstantFunctions';
import HadithPost from '../../components/HadithPost';
import Spinner from '../../../../Constants/Spinner';
import { hadithOfTheDayAction, hadithSearchAction, updateHadithAction } from '../../../../module/action/Hadith';
import DropDownIcon from '../../../../Assets/Icons/DropDownIcon';
import CancelIcon from '../../../../Assets/Icons/CancelIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import { Link } from 'react-router-dom';
import PastHadithRow from './PastHadithRow';
import { Pagination } from 'antd';

const PAGE_SIZE = 10;

const SelectDate = ({ past, setPast, month, setMonth, year, setYear }) => {
  return past ? (
    <div>
      {/* <h4 className="font-semibold text-sm opacity-0">history</h4> */}

      <div className="flex justify-between  w-full items-end">
        <label className="w-[calc(50%-8px)] h-[56px] relative flex items-center">
          <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />
          <select
            value={month}
            className='selectInput rounded-xl border-[1px] border-[#2A9134] bg-[#eef7ef] text-[#0e3a1e] w-full h-full font-["Poppins-ExtraBold"]  px-6 outline-none'
            onChange={ev => {
              setMonth(ev.target.value);
            }}>
            {monthArr.map((a, i) => (
              <option key={i} value={i}>
                {a}
              </option>
            ))}
            {/* 
            <option>July</option> */}
          </select>
        </label>
        <label className="w-[calc(50%-8px)] h-[56px] relative flex items-center">
          <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />
          <select
            className='selectInput rounded-xl border-[1px] border-[#0e3a1e] bg-[#0e3a1e] text-white font-["Poppins-ExtraBold"] w-full h-full px-6 outline-none'
            onChange={ev => {
              setYear(ev.target.value);
            }}>
            {getLast10Years().map((a, i) => (
              <option key={a} value={a}>
                {' '}
                {a}
              </option>
            ))}
            {/* <option>2022</option> */}
          </select>
        </label>
      </div>
    </div>
  ) : (
    <div className="cursor-pointer" onClick={() => setPast(!past)}>
      {/* <h4 className="font-semibold text-sm opacity-0">history</h4> */}
      <div className="flex items-center justify-between bg-[#eef7ef] px-6 rounded-s-lg w-full h-[58px] mt-[18px]">
        <p className="text-[#0e3a1f] font-bold">Today</p>
        <p dir="ltr" className="urduText text-[#0e3a1f] text-xl font-bold">
          {getPersianDayOfWeek(new Date())} {persianDate(new Date())}
        </p>
      </div>
    </div>
  );
};

function Hadith() {
  const dispatch = useDispatch();
  const hadithSearchData = useSelector(e => e.Hadith.hadithSearchData);
  const totalDocuments = useSelector(e => e.Hadith.totalDocuments);
  const hadithOfTheDayData = useSelector(e => e.Hadith.hadithOfTheDayData);
  const hadithOfTheMonthData = useSelector(e => e.Hadith.hadithOfTheMonthData);
  const [past, setPast] = useState(false);
  const [activeIndex, setActiveIndex] = useState([0, 2]);
  const [selectedHadith, setSelectedHadith] = useState(0);
  const [text, setText] = useState('');

  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    // if (!past) {\
    dispatch(
      hadithOfTheDayAction(
        !past ? new Date().toISOString() : false,
        past ? pad(+month + 1) : false,
        past ? year : false
      )
    );
    // }
  }, [past, month, year]);

  useEffect(() => {
    setPageNumber(1); // reset page number when filter criteria changes
    dispatch(
      hadithSearchAction(
        text,
        !past ? new Date().toISOString() : false,
        past ? pad(month + 1) : false,
        past ? year : false,
        pageNumber,
        PAGE_SIZE
      )
    );
  }, [text]);

  const [deleteHadithOfDayLoader, setDeleteHadithOfDayLoader] = useState(false);

  const addToDay = (data, setConfirmLoader, date) => {
    if (hadithSearchData.length) {
      let obj = {
        ...data,
        hadith_date_post: date,
        book: data.book?.length ? data.book[0]._id : null,
        volume: data.volume?.length ? data.volume[0]._id : null,
        categories: data.categories?.map(c => c._id).join(','),
      };

      dispatch(
        updateHadithAction(
          obj,
          data._id,
          setConfirmLoader,
          text,
          !past ? new Date().toISOString() : false,
          past ? pad(month + 1) : false,
          past ? year : false
        )
      );
      // }
    }
  };
  const changeFunction = ev => {
    setText(ev.target.value);
  };
  const [todayHadith, setTodayHadith] = useState(false);
  useEffect(() => {
    if (hadithOfTheDayData.length) {
      setTodayHadith(hadithOfTheDayData[0]);
    } else {
      setTodayHadith(false);
    }
  }, [hadithOfTheDayData]);

  const [monthHadith, setMonthHadith] = useState(false);

  useEffect(() => {
    setMonthHadith(hadithOfTheMonthData);
  }, [hadithOfTheMonthData]);

  return (
    <div className="Hadith my-12 px-8 innerDashboard">
      {/* <Logo /> */}
      <div className="header  justify-between flex">
        <div className="flex align-middle  flex-col">
          <h2 className="text-[32px] font-extrabold ">Hadith of the day</h2>
          <p className="font-bold text-[13px] text-[#00000066]">* Choose a post to make it Hadith of the day</p>
        </div>
      </div>
      <div className="flex justify-between lg:items-end lg:items-center mt-11 lg:flex-row flex-col flex-wrap">
        {past ? (
          <h4 className="font-semibold text-sm flex items-center  w-full mb-[4px]">
            Post Hadith of the day To
            <p className="flex items-center text-xl bg-[#eef7ef] ml-2 text-[#0e3a1e] px-6 py-[10.5px] urduText rounded-full leading-[11px]">
              <span className="cursor-pointer" onClick={() => setPast(!past)}>
                <CancelIcon className="ml-[8px]" />
              </span>
              {/* <span> */}
              {persianDate(new Date())}
              {/* </span> */}
            </p>
          </h4>
        ) : null}
        <div className="searchText lg:w-[calc(50%-15px)] w-full">
          <SearchInput
            placeHolder={'Write any word of hadith, Hadith number or Hadith reference'}
            searchText={!past}
            changeFunction={changeFunction}
            marginTop={'mt-0'}
          />
        </div>
        <div className="w-[calc(50%-15px)] lg:mt-0 mt-[16px] lg:block hidden">
          <SelectDate past={past} setPast={setPast} month={month} setMonth={setMonth} year={year} setYear={setYear} />
        </div>
      </div>
      <div className="hadithList flex justify-between lg:flex-row flex-col">
        <div className=" lg:w-[calc(50%-15px)] w-full">
          {hadithSearchData &&
            hadithSearchData.map((a, i) => (
              <HadithPost
                addToDay={addToDay}
                data={a}
                index={i}
                selectedHadith={selectedHadith}
                setSelectedHadith={setSelectedHadith}
              />
            ))}
          <div className="w-full flex justify-center items-center">
            <Pagination
              className="mt-6"
              showSizeChanger={false}
              onChange={pageNumber => {
                setPageNumber(pageNumber);
                dispatch(
                  hadithSearchAction(
                    text,
                    !past ? new Date().toISOString() : false,
                    past ? pad(month + 1) : false,
                    past ? year : false,
                    pageNumber,
                    PAGE_SIZE
                  )
                );
              }}
              current={pageNumber}
              pageSize={PAGE_SIZE}
              total={totalDocuments}
            />
          </div>
        </div>
        <div className=" lg:w-[calc(50%-15px)] w-full">
          <div className="w-full lg:mt-0 mt-[16px] lg:hidden block">
            <SelectDate past={past} setPast={setPast} month={month} setMonth={setMonth} year={year} setYear={setYear} />
          </div>

          {past ? (
            <>
              {/* <div className='mt-2'> */}
              {monthHadith &&
                monthHadith.map((a, i) => (
                  <PastHadithRow
                    a={a}
                    i={i}
                    addToDay={addToDay}
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                  />
                ))}
              {/* </div> */}
            </>
          ) : (
            <>
              <div className="w-full">
                {todayHadith ? (
                  <>
                    <div className="items-center justify-between bg-[#eef7ef] border-[#2a9134] border-[1px] px-6 py-6 rounded-lg w-full mt-[16px]">
                      <div className="flex items-center justify-end w-full mb-6 relative">
                        <div className="w-[24px] h-[24px] "></div>
                        <div className="flex items-center justify-center   text-text-ellipsis">
                          <p
                            dir="ltr"
                            className="line-clamp-1 text-ellipsis  urduText font-normal text-[#0e3a1f] text=[20px]  text-text-ellipsis">
                            {catTreeWithfahrast(todayHadith)}
                          </p>
                          <span className="line-clamp-1 text-ellipsis  numberHaith font-bold urduText ml-[16px] text-[#0e3a1f] text-[21px]">
                            {todayHadith.reference}
                          </span>
                        </div>
                      </div>
                      <p dir="ltr" className="urduText leading-[36px] font-bold line-clamp-4 text-text-ellipsis">
                        {todayHadith.preview}
                      </p>
                    </div>
                    <div className="flex items-center justify-between  mt-[16px]">
                      <Link className="h-[48px] w-[48%]" to={`/edit-post?id=${todayHadith._id}`}>
                        <button className="flex items-center justify-center h-full w-full bg-[#eef2f0] rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
                          <EditIcon width={26} height={24} fill="#000" />
                        </button>
                      </Link>
                      <button
                        disabled={deleteHadithOfDayLoader}
                        className="relative flex items-center justify-center h-[48px] w-[48%] bg-[#ca3030] rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105"
                        onClick={() => addToDay(todayHadith, setDeleteHadithOfDayLoader, '')}>
                        {deleteHadithOfDayLoader ? <Spinner /> : null}

                        <span
                          className={
                            deleteHadithOfDayLoader
                              ? `opacity-0 flex items-center justify-center`
                              : 'flex items-center justify-center'
                          }>
                          <DeleteIcon svgProps={{ className: 'w-[24px] h-[24px]' }} pathProp={{ fill: '#fff' }} />
                        </span>
                      </button>
                    </div>
                  </>
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Hadith;
